<template>
  <b-row>

    <!--          Name-->
    <b-col md="8">
      <field
          :name="'name'"
          :rules="'required'"
          :model.sync="article.name"
      />
    </b-col>

    <!--          Supplier reference-->
    <b-col md="4">
      <field
          :name="'supplierReference'"
          :model.sync="article.supplierReference"
      />
    </b-col>

    <!--        Unit price-->
    <b-col md="4">
      <field
          :name="'unitPrice'"
          :model.sync="article.unitPrice"
      />
    </b-col>

    <!--        VAT-->
    <b-col md="4">
      <field-select
          :name="'VAT'"
          :model.sync="article.vatRate"
          :options="vats"
          :label="'name'"
          :placeholder="$t('Choose an VAT')"
          :clearable="false"
      />
    </b-col>

    <!--          Unity-->
    <b-col md="4">
      <field
          name="unity"
          :model.sync="article.unity"
      />
    </b-col>

    <!--          isDeliverable-->
    <b-col md="4" class="mb-1">
      <div class="my-auto">
        <div class="d-flex">
          <b-form-checkbox
              v-model="article.isDeliverable"
              class="custom-control-primary my-auto"
              switch
          />
          <span class="my-auto text-nowrap">{{ capitalize($t('isDeliverable')) }}</span>
        </div>
      </div>
    </b-col>

    <!--          tags-->
    <b-col md="4" class="mb-1">
<!--      <field-select-->
<!--          :model.sync="article.tags"-->
<!--          :multiple="true"-->
<!--          name="tags"-->
<!--          :reduce="null"-->
<!--          :options="tagsOptions"-->
<!--      />-->

      <v-select
          :multiple="true"
          v-model="article.tags"
          :append-to-body="true"
          :options="tagsOptions"
          class="w-100"
      />
    </b-col>

    <!--        Description-->
    <b-col cols="12">
      <field-textarea
          :model.sync="article.description"
          name="description"
          placeholder="description"
      />
    </b-col>

  </b-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import Field from '@/components/input/Input'
import FieldSelect from '@/components/input/Select'
import FieldTextarea from '@/components/input/Textarea'
import useAPI from '@/utils/useAPI'
import { capitalize } from '../../utils/filter'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    Field,
    FieldSelect,
    FieldTextarea,
  },
  props: {
    article: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const tagsOptions = ref(["Ergonomie", "Presta exo", "Exo", "Location exo", "Expédition",  "Consommable", "Ventes additionnelles"])

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { vats } = useAPI()

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data
      tagsOptions,

      // Computed
      vats,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: { capitalize },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>